const rewardFunctionKeys = {
    all: ['reward-functions'] as const,
};

export default rewardFunctionKeys;
